import React from "react";
import { useLang } from "../lib/LanguageContext";
import { ASSETS, CONTACT_EMAIL } from "../lib/content";
import { Mail } from "lucide-react";

export default function Footer() {
    const { t } = useLang();

    return (
        <footer
            className="relative border-t border-[color:var(--sau-border)] bg-[#070E1A]"
            data-testid="sau-footer"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 pt-14 sm:pt-16 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src={ASSETS.logoTransparent}
                                alt="SAU"
                                className="h-10 w-10 object-contain"
                            />
                            <div>
                                <div className="text-sm tracking-[0.22em] font-semibold">SAU</div>
                                <div className="text-[11px] tracking-[0.16em] uppercase text-[color:var(--sau-muted)]">
                                    {t.meta.brandFull}
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-sm leading-relaxed text-[color:var(--sau-text-2)] max-w-md">
                            {t.footer.tagline}
                        </p>

                        {/* Institutional contact block */}
                        <div className="mt-6" data-testid="sau-footer-contact">
                            <div className="text-[11px] uppercase tracking-[0.24em] text-[color:var(--sau-muted)] mb-2.5">
                                {t.contact.eyebrow}
                            </div>
                            <a
                                href={`mailto:${CONTACT_EMAIL}`}
                                className="inline-flex items-center gap-2.5 h-10 px-3.5 rounded-full border border-[color:var(--sau-border)] bg-[#0B1A2B] hover:border-[color:var(--sau-accent)]/50 hover:text-[color:var(--sau-text)] transition-colors text-sm text-[color:var(--sau-text-2)]"
                                data-testid="sau-footer-email"
                            >
                                <Mail className="w-3.5 h-3.5 text-[color:var(--sau-accent)]" aria-hidden />
                                <span dir="ltr" className="font-medium">
                                    {CONTACT_EMAIL}
                                </span>
                            </a>
                        </div>
                    </div>

                    {t.footer.columns.map((col, i) => (
                        <div key={`fcol-${i}`} className="md:col-span-3">
                            <div className="text-[11px] uppercase tracking-[0.24em] text-[color:var(--sau-muted)] mb-4">
                                {col.title}
                            </div>
                            <ul className="space-y-3">
                                {col.links.map((l, j) => (
                                    <li key={`flink-${i}-${j}`}>
                                        <a
                                            href={l.href}
                                            className="text-sm text-[color:var(--sau-text-2)] hover:text-[color:var(--sau-text)] transition-colors"
                                        >
                                            {l.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="mt-10 sm:mt-12 pt-6 border-t border-[color:var(--sau-border)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <div className="text-xs text-[color:var(--sau-muted)]">
                        {t.footer.copyright}
                    </div>
                    <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[color:var(--sau-muted)]">
                        <span className="sau-badge-dot" />
                        <span>{t.hero.badge}</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
